<template>
  <div class="register">
    <div class="content">
      <h1 class="welcome">开始使用</h1>
      <p class="subtitle">创建一个账号以使用全部功能</p>

      <van-form @submit="onSubmit" class="form">
        <div class="input-group">
          <van-field
            v-model="username"
            name="username"
            placeholder="用户名"
            :rules="[{ required: true, message: '请填写用户名' }]"
            class="custom-field"
          />
          <van-field
            v-model="email"
            name="email"
            placeholder="邮箱"
            :rules="[
              { required: true, message: '请填写邮箱' },
              { pattern: /.+@.+\..+/, message: '请输入正确的邮箱格式' }
            ]"
            class="custom-field"
          />
          <van-field
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            name="password"
            placeholder="密码"
            :rules="[
              { required: true, message: '请填写密码' },
              { min: 6, message: '密码至少6位' }
            ]"
            class="custom-field"
          >
            <template #right-icon>
              <van-icon 
                :name="showPassword ? 'eye-o' : 'closed-eye'" 
                @click="showPassword = !showPassword"
                class="eye-icon"
              />
            </template>
          </van-field>
          <van-field
            v-model="confirmPassword"
            :type="showPassword ? 'text' : 'password'"
            name="confirmPassword"
            placeholder="确认密码"
            :rules="[
              { required: true, message: '请确认密码' },
              { validator: validatePassword, message: '两次输入的密码不一致' }
            ]"
            class="custom-field"
          />
        </div>
        
        <div class="submit-btn">
          <van-button block type="primary" native-type="submit">
            创建账号
          </van-button>
        </div>
      </van-form>

      <div class="login-link">
        已有账号？
        <a @click="goToLogin">立即登录</a>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import AV from 'leancloud-storage'
import { showToast, showSuccessToast } from 'vant'

export default {
  name: 'Register',
  setup() {
    const router = useRouter()
    const username = ref('')
    const email = ref('')
    const password = ref('')
    const confirmPassword = ref('')
    const loading = ref(false)
    const showPassword = ref(false)

    const validatePassword = () => {
      return password.value === confirmPassword.value
    }

    const onSubmit = async () => {
      if (!validatePassword()) {
        return
      }

      loading.value = true
      const user = new AV.User()
      user.setUsername(username.value)
      user.setPassword(password.value)
      user.setEmail(email.value)

      try {
        await user.signUp()
        showSuccessToast('注册成功')
        router.push('/login')
      } catch (error) {
        let errorMsg = '注册失败'
        switch (error.code) {
          case 202:
            errorMsg = '用户名已被占用'
            break
          case 203:
            errorMsg = '邮箱已被注册'
            break
          default:
            errorMsg = error.message
        }
        showToast({
          message: errorMsg,
          type: 'fail'
        })
      } finally {
        loading.value = false
      }
    }

    const onClickLeft = () => {
      router.back()
    }

    const goToLogin = () => {
      router.push('/login')
    }

    return {
      username,
      email,
      password,
      confirmPassword,
      loading,
      validatePassword,
      onSubmit,
      onClickLeft,
      goToLogin,
      showPassword
    }
  }
}
</script>

<style scoped>
.register {
  min-height: 100vh;
  height: 100vh;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px 0;
  min-height: min-content;
}

.welcome {
  font-size: 32px;
  font-weight: 600;
  margin: 0 0 8px;
  color: #000;
}

.subtitle {
  font-size: 16px;
  color: #86868b;
  margin: 0 0 40px;
}

.input-group {
  background: #f5f5f7;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 24px;
}

.custom-field {
  background: transparent;
}

:deep(.van-field) {
  padding: 14px 16px;
}

:deep(.van-field__control) {
  font-size: 16px;
}

:deep(.van-field__control::placeholder) {
  color: #86868b;
}

.eye-icon {
  color: #86868b;
  font-size: 20px;
}

.submit-btn {
  margin: 24px 0;
}

:deep(.van-button--primary) {
  background: #0071e3;
  border: none;
  height: 50px;
  font-size: 17px;
  font-weight: 400;
  border-radius: 12px;
}

:deep(.van-button--primary:active) {
  background: #0077ed;
}

.login-link {
  text-align: center;
  color: #86868b;
  font-size: 14px;
}

.login-link a {
  color: #0071e3;
  text-decoration: none;
  margin-left: 4px;
}
</style> 